import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var PhoneCall02 = function PhoneCall02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M4.8586 6c1.815-1.8514 4.344-3 7.1415-3s5.3265 1.1486 7.1414 3m-2.6692 3C15.3736 7.7725 13.777 7 12 7s-3.3735.7725-4.4722 2M12 17c1.5105 0 2.9608.2576 4.3094.7313.0448.0157.0673.0236.1026.0392.3206.1413.5668.4886.5938.8379.003.0386.003.0727.003.141 0 .2327 0 .3491.0097.4471a2 2 0 0 0 1.7938 1.7938c.098.0097.2144.0097.4471.0097h.245c.4606 0 .6908 0 .8824-.0378a2 2 0 0 0 1.5754-1.5754C22 19.1952 22 18.965 22 18.5044v-.1982c0-.4752 0-.7129-.0507-.9853-.1135-.609-.556-1.3626-1.0327-1.7585-.2131-.177-.3577-.2576-.6468-.4189C17.822 13.7781 15.0019 13 12 13s-5.822.7781-8.2698 2.1435c-.2891.1613-.4337.2419-.6468.4189-.4767.3959-.9192 1.1495-1.0327 1.7585C2 17.5933 2 17.831 2 18.3062v.1982c0 .4606 0 .6908.0378.8824a2 2 0 0 0 1.5754 1.5754C3.8048 21 4.035 21 4.4956 21h.245c.2327 0 .3491 0 .4471-.0097a2 2 0 0 0 1.7938-1.7938c.0097-.098.0097-.2144.0097-.4471 0-.0683 0-.1024.003-.141.027-.3493.2732-.6966.5938-.8379a1.2 1.2 0 0 1 .1026-.0392C9.0392 17.2576 10.4895 17 12 17"
    })
  }));
};
export default PhoneCall02;